import { BlurImage } from "image-config";
import Image, { ImageProps } from "next/image";
import { useCustomImage } from "@/components/hooks/useCustomImage.hook";

type CustomImageProps = Omit<ImageProps, "src"> & {
  src: string;
  alt?: string;
  width?: number;
  height?: number;
};

const CustomImage = ({
  alt,
  src,
  fill,
  priority,
  width,
  height,
  ...props
}: CustomImageProps) => {
  const { error, setError, imageSrc } = useCustomImage({ src });

  // Don't render if src is empty or invalid
  if (!src || src.trim() === "") {
    return (
      <div className="flex items-center justify-center bg-gray-100 text-gray-400">
        <span className="text-sm">No image</span>
      </div>
    );
  }

  // Prepare image props based on whether fill is used or not
  const imageProps: any = {
    ...props,
    priority: priority === true ? true : undefined,
  };

  // If fill is true, use fill mode; otherwise require width and height
  if (fill === true) {
    imageProps.fill = true;
  } else {
    // Provide default dimensions if not specified
    imageProps.width = width || 400;
    imageProps.height = height || 300;
  }

  return (
    <Image
      className="object-fill"
      alt={alt || "image"}
      onError={() => setError(true)}
      src={imageSrc}
      loading="lazy"
      placeholder="blur"
      blurDataURL={BlurImage}
      {...imageProps}
    />
  );
};

export default CustomImage;
